import Link from 'next/link'
import s from './breadcrumbs.module.css'
import cx from 'classnames'
import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'

export type Crumb = { label: string; href: string; disabled?: boolean }

type Props = {
  crumbs: Crumb[]
  className?: string
}

export const BreadCrumbsV3 = (props: Props) => {
  const crumbs = props.crumbs
  const className = props.className

  return (
    <nav className={cx(s.container, className)} aria-label="Breadcrumb">
      <ol className={s.list}>
        {crumbs.map(({ label, href, disabled }, index) => {
          const isFirst = index === 0
          const isLast = index === crumbs.length - 1
          return (
            <li key={label} className={s.listItem}>
              {disabled ? (
                <span className={s.link}>
                  {!isFirst && (
                    <ArrowRight
                      svgProps={{
                        width: 11,
                        height: 12,
                        className: s.arrow,
                      }}
                    />
                  )}
                  {label}
                </span>
              ) : (
                <Link
                  href={href}
                  className={cx(s.link, { [s.linkLast]: isLast })}
                >
                  {!isFirst && (
                    <ArrowRight
                      svgProps={{
                        width: 11,
                        height: 12,
                        className: s.arrow,
                      }}
                    />
                  )}
                  {label}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
